/* eslint-disable max-lines-per-function */
import type { Token } from '../../core/token';

export default (): Partial<Token> => ({
  dvStandardChart: {
    baseOption: {
      dataZoom: [
        {
          type: 'slider',
          show: false,
          moveOnMouseMove: false,
          zoomOnMouseWheel: false,
          backgroundColor: '#F2F5FA',
          fillerColor: '#DADDE0',
          borderColor: '#DADDE0',
          handleIcon:
            'image://data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cmVjdCB4PSI0IiB3aWR0aD0iOCIgaGVpZ2h0PSIxNiIgcng9IjEiIGZpbGw9IiMxQTlGRkYiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYgNS41QzYgNS4yMjM4NiA2LjIyMzg2IDUgNi41IDVIOS41QzkuNzc2MTQgNSAxMCA1LjIyMzg2IDEwIDUuNUMxMCA1Ljc3NjE0IDkuNzc2MTQgNiA5LjUgNkg2LjVDNi4yMjM4NiA2IDYgNS43NzYxNCA2IDUuNVpNNiA4QzYgNy43MjM4NiA2LjIyMzg2IDcuNSA2LjUgNy41SDkuNUM5Ljc3NjE0IDcuNSAxMCA3LjcyMzg2IDEwIDhDMTAgOC4yNzYxNCA5Ljc3NjE0IDguNSA5LjUgOC41SDYuNUM2LjIyMzg2IDguNSA2IDguMjc2MTQgNiA4Wk02LjUgMTBDNi4yMjM4NiAxMCA2IDEwLjIyMzkgNiAxMC41QzYgMTAuNzc2MSA2LjIyMzg2IDExIDYuNSAxMUg5LjVDOS43NzYxNCAxMSAxMCAxMC43NzYxIDEwIDEwLjVDMTAgMTAuMjIzOSA5Ljc3NjE0IDEwIDkuNSAxMEg2LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4='
        }
      ],
      legend: {
        backgroundColor: 'rgba(0, 0, 0, 0)'
      },
      series: [
        {
          type: 'wordCloud',
          dvTextColors: [
            '#090E18',
            '#313A4F',
            '#4D576F',
            '#848D9F',
            '#9EA8B5',
            '#A9B2BE',
            '#A9B2BE'
          ]
        }
      ]
    }
  },

  // * --- echarts theme  @see https://echarts.apache.org/zh/theme-builder.html
  backgroundColor: 'rgba(255, 255, 255, 1)',
  titleColor: '#313438',
  axes: [
    {
      type: 'all',
      name: 'universal axis',
      axisLineShow: true,
      axisLineColor: '#6e7079',
      axisTickShow: false,
      axisTickColor: '#6e7079',
      axisLabelShow: true,
      axisLabelColor: '#6E7079',
      splitLineShow: true,
      splitLineColor: ['#E0E6F1'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.2)', 'rgba(210,219,238,0.2)']
    },
    {
      type: 'category',
      name: 'category axis',
      axisLineShow: true,
      axisLineColor: '#92989f',
      axisTickShow: false,
      axisTickColor: '#92989f',
      axisLabelShow: true,
      axisLabelColor: '#787e87',
      splitLineShow: true,
      splitLineColor: ['#f3f4f6'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(255,0,0,0.2)']
    },
    {
      type: 'value',
      name: 'value axis',
      axisLineShow: true,
      axisLineColor: '#92989f',
      axisTickShow: false,
      axisTickColor: '#6E7079',
      axisLabelShow: true,
      axisLabelColor: '#787e87',
      splitLineShow: true,
      splitLineColor: ['#f3f4f6'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.2)', 'rgba(210,219,238,0.2)']
    },
    {
      type: 'log',
      name: 'log axis',
      axisLineShow: true,
      axisLineColor: '#92989f',
      axisTickShow: false,
      axisTickColor: '#6E7079',
      axisLabelShow: true,
      axisLabelColor: '#787e87',
      splitLineShow: true,
      splitLineColor: ['#f3f4f6'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.2)', 'rgba(210,219,238,0.2)']
    },
    {
      type: 'time',
      name: 'time axis',
      axisLineShow: true,
      axisLineColor: '#92989f',
      axisTickShow: false,
      axisTickColor: '#6E7079',
      axisLabelShow: true,
      axisLabelColor: '#787e87',
      splitLineShow: true,
      splitLineColor: ['#f3f4f6'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.2)', 'rgba(210,219,238,0.2)']
    }
  ],

  // * --- UED Token -----------------------------------------------------------------------------------
  '--color-background-weak': 'rgba(0,0,0,0.04)',

  '--color-visualization-divider': 'rgba(0,0,0,0.06)',
  '--color-visualization-tooltip': '#3b3b3b',

  '--color-text-primary': 'rgba(0,0,0,0.84)',
  '--color-text-secondary': 'rgba(0,0,0,0.6)',
  '--color-text-tertiary': 'rgba(0,0,0,0.4)',
  '--color-text-quaternary': 'rgba(0,0,0,0.24)',
  '--color-text-inverse': '#ffffff',
  '--color-text-link': '#4167d9',

  '--color-grey-01': '#e6e6e6',
  '--color-grey-02': '#d1d1d1',
  '--color-grey-03': '#b3b3b3',
  '--color-grey-04': '#9c9c9c',
  '--color-grey-05': '#858585'
});
